import { render } from "./EditorAttachment.vue?vue&type=template&id=1f81a287"
import script from "./EditorAttachment.vue?vue&type=script&lang=js"
export * from "./EditorAttachment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__